import { IOriginCoupon, ICouponApplied, ICouponNotApply } from 'types/coupon';

export const mapAppliedCoupons = (coupon: IOriginCoupon): ICouponApplied => {
    return {
        id: `${coupon.id}`,
        metaId: `${coupon.coupon_meta_id}`,
        type: coupon.type,
        validPeriod: coupon.valid_period || 0,
        periodType: coupon.period_type,
        shopName: coupon.shop_name,
        couponName: coupon.coupon_name,
        discount: coupon.discount,
        credit: coupon.credit,
        threshold: coupon.threshold,
        maxDiscountLimit: coupon.max_discount_limit,
        createTime: coupon.create_time,
        startTime: coupon.start_time,
        beginTime: coupon.begin_time,
        endTime: coupon.end_time,
        typeString: coupon.type_string,
        isShow: coupon.is_show,
        url: coupon.url || '',
        popUpText: coupon.pop_up_text || '',
        shopId: coupon.shop_id,
        explain: [],
        platformSubType: coupon.platform_sub_type,
        typeDetail: coupon.type_detail,
        kolUid: coupon.kol_uid,
        productIds: coupon.product_ids || [],
        coupon_meta_id: coupon.coupon_meta_id,
        kolUserTag: coupon.kol_user_tag,
        kolScopeTag: coupon.kol_scope_tag
    };
};
export const mapNotApplyCoupons = (coupon: IOriginCoupon): ICouponNotApply => {
    return {
        metaId: `${coupon.coupon_meta_id}`,
        type: coupon.type,
        validPeriod: coupon.valid_period || 0,
        periodType: coupon.period_type,
        shopName: coupon.shop_name,
        couponName: coupon.coupon_name,
        discount: coupon.discount,
        credit: coupon.credit,
        threshold: coupon.threshold,
        maxDiscountLimit: coupon.max_discount_limit,
        createTime: coupon.create_time,
        startTime: coupon.start_time,
        beginTime: coupon.begin_time,
        endTime: coupon.end_time,
        typeString: coupon.type_string,
        isShow: coupon.is_show,
        leftAmount: coupon.left_amount,
        userApplyTimes: coupon.user_apply_times,
        maxApplyTimes: coupon.max_apply_times,
        kolUserTag: coupon.kol_user_tag
    };
};
